export const generateUUID = () => {
  let d = new Date().getTime()
  let uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      let r = ((d + Math.random() * 16) % 16) | 0
      d = Math.floor(d / 16)
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16)
    }
  )
  return uuid
}

export const getIndex = (arr, strId) => {
  let item = arr.find(el => el.id === strId)
  let idx = arr.indexOf(item)

  return idx
}

export const alphabetize = (arr, strField) => {
  let arrAlphabetized = arr.sort((a, b) => {
    let elA = a[strField].toUpperCase()
    let elB = b[strField].toUpperCase()
    return (elA < elB) ? -1 : (elA > elB) ? 1 : 0
  })
  return arrAlphabetized
}

export const sortByDate = (arr, strField) => {
  return arr.sort((a, b) => a[strField] < b[strField])
}

export const copyObject = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}


// WEBPACK FOOTER //
// ./src/mixins/utilities.js